import { apiErrorsToArray, isFunction, isObj } from '@helpers/utils.js'
import { defaultErrorToast, addToast } from '@composables/useToast.js'
import errorMessages from '@errors/ErrorMessages.js'
import useRoute from '@composables/useRoute.js'
import i18n from '@plugins/localisation.js'

export default function () {
  const { routeError, push, routeParams } = useRoute()

  function handleError({
    error,
    errorState,
    errorCodeState = {},
    errorRefState = {},
    disableRouteHandling = false,
    routeHandlerOrErrorMessage = null,
  }) {
    let errorText
    if (error.errors?.length || isObj(error.errors)) {
      errorState.value = error.errors
      errorText = apiErrorsToArray(error.errors)
    } else if (error.message) {
      errorState.value = errorMessages.getErrorMessage(error.message)
      errorText = errorState.value
    } else {
      const defaultError = i18n.global.t('default_error_message')
      errorState.value = defaultError
      errorText = defaultError
    }

    errorCodeState.value = error.code
    errorRefState.value = error.errorRef

    if (!disableRouteHandling) {
      const config = _getErrorConfig(error)
      if (config) _handle(config, error)
      else if (routeHandlerOrErrorMessage) {
        addToast({
          title: routeHandlerOrErrorMessage,
          isError: true,
          text: apiErrorsToArray(errorState.value)?.join(' '),
          errorRef: errorRefState.value || '0',
        })
      }
    }

    const errorMessage = `code: ${error.code} | errorRef: ${error.errorRef} | errorMessage: ${errorText} `
    console.error(errorMessage)
  }

  function _getErrorConfig(error) {
    if (!routeError.value || !error) return null
    return routeError.value.find(
      (c) =>
        _matchMethod(c, error) &&
        _matchStatus(c, error) &&
        _matchErrorRef(c, error)
    )
  }

  function _handle(config, error) {
    if (!config) return
    if (config.toast) {
      if (isFunction(config.toast)) {
        addToast({ isError: true, ...config.toast(error) })
      } else {
        defaultErrorToast()
      }
    }

    if (config.redirect) {
      push({ name: config.redirect })
    } else if (config.action) {
      _handleAction(config.action, error)
    }
  }

  function _handleAction(cb, error) {
    cb(routeParams.value, error)
  }

  function _matchStatus(config, error) {
    if (config.status === '*') return true

    return config.status === error.code
  }

  function _matchMethod(config, error) {
    if (config.method === '*') return true
    return config.method === error.method
  }

  function _matchErrorRef(config, error) {
    if (config.errorRef === '*') return true
    return config.errorRef === error.errorRef
  }
  return {
    handleError,
  }
}
